import { useState } from 'react';
import { Carousel } from 'react-bootstrap';

function CustomersSay() {
  return (
    <div className="customersSay__conteiner">
      <div className="customersSay__wrapper">
        <div className="customersSay__content column">
          <div className="customersSay__title column">
            <h1>고객들의 평가</h1>
          </div>
          <ControlledCarousel/>
        </div>
      </div>
    </div>
  );
}

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} controls={false} onSelect={handleSelect} className="carousel__slide-container">
      <Carousel.Item className="carousel__slide">
        <p className="slide__text"> 초록입홍합 37000을 꾸준히 복용했더니 눈에 띌 정도로 무릎의 상태가 좋아졌고, 통증이나 붓기가 줄어들었어요. 아프지 않고 지낼 수 있다니 믿을 수가 없어요. 고마워요! </p>
        <p className="slide__name"> George Martin D. </p>
      </Carousel.Item>
      <Carousel.Item className="carousel__slide">
        <p className="slide__text"> 이 제품들이 정말 인상적이라는 걸 말하고 싶네요, 초록입홍합 오일을 6개월 정도 사용해왔는데, 무릎 관절염과 통증이 줄어드는데 정말로 도움이 되었어요.</p>
        <p className="slide__name"> Mike D. </p>
      </Carousel.Item>
      <Carousel.Item className="carousel__slide">
        <p className="slide__text"> 사과식초 캡슐은 쓴맛 없이 효능을 얻을 수 있는 최적의 방법인 거 같아요. 해독과 과민성 대장 증후군을 호전 시키는데 도움이 되었어요. </p>
        <p className="slide__name"> Jane M. </p>
      </Carousel.Item>
    </Carousel>
  );
}
export default CustomersSay;